<template>
    <div>
        <template v-for="option in filter.inputs.value.options" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="'opt-' + option.value">
                    <input
                        :id="'opt-' + option.value"
                        v-model="value"
                        type="radio"
                        name="options[]"
                        :value="option.value"
                    />
                    {{ option.label }}
                </label>
            </div>
        </template>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],

    data() {
        return {
            value: [],
        };
    },

    computed: {
        data() {
            return {
                value: this.value,
            };
        },
    },
};
</script>
